import useStore from "../../../store"
import RiskSquare from "./RiskSquare"

export default function MyRiskMetrics() {
  const dailyOps = useStore((state) => state.dailyOps)
  const dealerTableFilterParams = useStore((state) => state.dealerTableFilterParams)
  const setDealerTableFilterParams = useStore((state) => state.setDealerTableFilterParams)
  const setSelectedDealerScopeLabel = useStore((state) => state.setSelectedDealerScopeLabel)

  const handleClick = (scope, label) => {
    setDealerTableFilterParams({
      ...dealerTableFilterParams,
      "scope": scope
    })
    setSelectedDealerScopeLabel(label)
  }

  return(
    <div className="flex justify-center w-full pb-2 pt-3 px-4 lg:px-8 bg-grey-900">
      <div className="flex flex-col w-full">
        <div className='lg:flex lg:flex-wrap md:flex md:flex-wrap gap-3 grid grid-cols-3 w-full justify-evenly'>
          <div onClick={() => {handleClick("with_untouched_units", "with Units Untouched 60+ Days")}}>
            <RiskSquare
              text={"Untouched 60+ Days"}
              riskMetric={dailyOps.sixty_day_count}
            />
          </div>
          <div onClick={() => {handleClick("with_sold_units", "with Sold Units")}}>
            <RiskSquare
              text={"Sold Units"}
              riskMetric={dailyOps.sold_units}
            />
          </div>
          <div onClick={() => {handleClick("with_past_due_units", "with Past Due Units")}}>
            <RiskSquare
              text={"Past Due Units"}
              riskMetric={dailyOps.past_due_units}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
